import React from "react";

type Props = {
    label?: string;
};

export default function FileUpload(props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & Props) {
    return (
        <div className="">
            <label
                htmlFor={props.id}
                className="block text-sm/6 font-medium text-gray-900 mb-2"
                dangerouslySetInnerHTML={{
                    __html: props.label,
                }}
            />
            <input
                type="file"
                id={props.id}
                onChange={props.onChange}
                className="w-full border border-gray-300 text-gray-500 font-medium text-sm bg-gray-100 file:cursor-pointer cursor-pointer file:border file:border-gray-800 file:py-2 file:px-4 file:mr-4 file:bg-gray-800 file:hover:bg-gray-700 file:text-white rounded"
            />
        </div>
    );
}